import { useEffect, useState } from "react";
import Page from "../../Page";
import LearningPathReportHomeDetailSection from "./LearningPathReportHomeDetailSection";
import CONFIG from "../../../utils/config";

export const LearningPathOfficeDetailMobilePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    let sendHeight = setInterval(() => {
      let obj = {
        method: "height",
        value: document.getElementById("root").scrollHeight + 100,
      };
      console.log("height: ", obj);
      window.parent.postMessage(obj, "*");
    }, 3000);

    return () => {
      clearInterval(sendHeight);
    };
  }, []);

  return (
    <div className="container">
      <LearningPathReportHomeDetailSection isMobile={true} />
    </div>
  );
};

export default LearningPathOfficeDetailMobilePage;
